import styled from 'styled-components'

export const StyledDetailPanel = styled.div<{
  $isOpen: boolean
  $width: string
  $isResizing: boolean
  $contained?: boolean
}>`
  position: ${({ $contained }) => ($contained ? 'absolute' : 'fixed')};
  top: ${({ $contained }) => ($contained ? '0' : '64px')};
  right: 0;
  width: ${({ $width }) => $width};
  ${({ $contained }) =>
    $contained ? 'bottom: 0; max-width: 90%;' : 'height: calc(100vh - 64px);'}
  background: ${({ theme }) => theme.colors.background.primary};
  box-shadow: ${({ $isOpen, theme }) => ($isOpen ? theme.shadows.xl : 'none')};
  transform: translateX(${({ $isOpen }) => ($isOpen ? '0' : '100%')});
  transition: ${({ $isResizing }) =>
    $isResizing
      ? 'none'
      : 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.5s cubic-bezier(0.4, 0, 0.2, 1)'};
  z-index: ${({ $contained, theme }) =>
    $contained ? '1000' : theme.zIndex.modal};
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-width: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 100%;
    max-width: 100%;
  }
`

export const StyledDetailPanelHeader = styled.div`
  background: ${({ theme }) => theme.colors.background.primary};
  padding: ${({ theme }) => theme.spacing.large}
    ${({ theme }) => theme.spacing.xlarge};
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 10;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: ${({ theme }) => theme.spacing.medium};
  }
`

export const StyledDetailPanelContent = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
  position: relative;
  max-width: 100%;
  min-width: 0;

  /* Ensure all child elements respect container width */
  & > * {
    max-width: 100%;
    min-width: 0;
  }
`

export const StyledDetailPanelFooter = styled.div`
  background: ${({ theme }) => theme.colors.background.primary};
  border-top: 1px solid ${({ theme }) => theme.colors.border.light};
  padding: ${({ theme }) => theme.spacing.large}
    ${({ theme }) => theme.spacing.xlarge};
  display: flex;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.medium};
  flex-shrink: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: ${({ theme }) => theme.spacing.medium};
    gap: ${({ theme }) => theme.spacing.small};
    flex-wrap: wrap;
  }
`

export const ResizeHandle = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 12px;
  height: 100%;
  cursor: col-resize;
  background: transparent;
  transition: background-color 0.2s ease;
  z-index: 1001;
  display: block;

  &:hover {
    background: ${({ theme }) => theme.colors.primary}20;
  }

  &:active {
    background: ${({ theme }) => theme.colors.primary}40;
  }

  &::before {
    content: '';
    position: absolute;
    left: 4px;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 80px;
    background: ${({ theme }) => theme.colors.border.default};
    border-radius: 2px;
    opacity: 0.6;
    transition: all 0.2s ease;
  }

  &:hover::before {
    opacity: 1;
    background: ${({ theme }) => theme.colors.primary};
    height: 120px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: none;
  }
`
